import {
  AutocompleteChangeReason,
  Button,
} from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import genericStyles from "../../Styles/genericStyles.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ClientModel } from "../../Utils/Models";
import ClientForm from "./ClientForm";
import GenericModal from "../GenericModal";
import { EWidths } from "../../Utils/Enums";
import { EditClientModalProps } from "../../Utils/Types";
import { FormsIds } from "../../Utils/Constants";

export const EditClientModal = (props: EditClientModalProps) => {
  const ref: any = useRef();
  const {open, setOpen} =  props;
  const [openNew, setOpenNew] = useState(false);
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  const handleChangePressOnSubmit = () => {
    setPressOnSubmit(!pressOnSubmit);
  };

  /**
   *
   * @param e
   * @param client
   * @param reason
   * @param details
   */
  const onClientSuccess = (
    e: any,
    client: ClientModel,
    reason: AutocompleteChangeReason,
    details?: any
  ) => {
    props.onClientChange(e, client, reason, details);
  };

  return (
    <Fragment>
      <GenericModal
        onClose={() => {
          setOpen(false);
          setOpenNew(false);
        }}
        maxWidth={EWidths.MD}
        open={open || openNew}
        actions={
          <div className={genericStyles.modalActions}>
            <Button
              color="secondary"
              variant="outlined"
              fullWidth
              onClick={() => {
                setOpen(false);
                setOpenNew(false);
              }}
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              fullWidth
              type="submit"
              form={FormsIds.clients}
              variant="contained"
            >
              {Vocabulary.save}
            </Button>
          </div>
        }
        title={Vocabulary.editModalTitle}
      >
        <ClientForm
          onSuccess={onClientSuccess}
          selectedClient={
            openNew ? new ClientModel() : props.getValues("client_id")
          }
          onClose={() => {
            setOpen(false);
            setOpenNew(false);
          }}
        />
      </GenericModal>
    </Fragment>
  );
};
